import Logger from 'utilities/logger';
import Fingerprint from 'fingerprintjs2';

const useFingerprint = (onFingerprint, onError) => {
  const logger = Logger('useFingerprint');
  let attempts = 0;

  const getFingerprint = () => {
    Fingerprint.get({}, components => {
      if (!components) {
        attempts++;
        if (attempts > 2) {
          const message = 'Fingerprint did not return any data';
          logger.error(new Error(message));
          onError(message);
        }
        setTimeout(() => getFingerprint(), 1000);
      } else {
        const values = components.map(({ value }) => value);
        const hash = Fingerprint.x64hash128(values.join(''), 31);
        onFingerprint(hash);
      }
    });
  };

  return getFingerprint;
};

export default useFingerprint;
